import { render } from "./userCard.vue?vue&type=template&id=0d31478e&scoped=true"
import script from "./userCard.vue?vue&type=script&lang=js"
export * from "./userCard.vue?vue&type=script&lang=js"

import "./userCard.vue?vue&type=style&index=0&id=0d31478e&lang=scss&scoped=true"
import "./userCard.vue?vue&type=style&index=1&id=0d31478e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d31478e"]])

export default __exports__